import Vue from 'vue';
import Component from 'vue-class-component';
import {ITableColumn} from '@/entity/table/table.types';
import i18n from '@/locales';

@Component
export class ClientLoyaltyTableMix extends Vue {
  get LoyaltyColumns(): ITableColumn[] {
    return [
      {
        title: i18n.t('certificate.number') as string, dataIndex: 'code', key: 'code',
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
        },
      },
      {
        title: i18n.t('loyalty.type') as string, dataIndex: 'type_name', key: 'type_name',
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
        },
      },
      {
        title: i18n.t('loyalty.faceValue') as string, dataIndex: 'balance', key: 'balance',
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
        },
      },
      {
        title: i18n.t('certificate.activationDate') as string,
        dataIndex: 'active_from',
        key: 'active_from',
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: 'activeFrom',
        },
      },
      {
        title: i18n.t('certificate.deactivationDate') as string,
        dataIndex: 'active_to',
        key: 'active_to',
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: 'activeTo',
        },
      },
      {
        title: i18n.t('certificate.status') as string,
        dataIndex: 'active',
        key: 'active',
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: 'status',
        },
      },
      {
        title: i18n.t('certificate.amountInStock') as string,
        dataIndex: 'balance',
        key: 'balance',
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
        },
      },
    ];
  }
}
